// "Exigir troca de senha no próximo acesso". O token do login traz a marca
// `troca_senha` quando o gestor ligou a exigência; enquanto ela existir, a
// sessão só usa a tela "Defina sua nova senha". O backend faz o mesmo na API
// (checkRole devolve 403 com o código TROCA_SENHA_OBRIGATORIA).
export const ROTA_TROCA_SENHA = '/definir-nova-senha';
export const CODIGO_TROCA_SENHA = 'TROCA_SENHA_OBRIGATORIA';

export const sessaoComTrocaPendente = (usuario) => usuario?.troca_senha === true;

// Fora da tela de troca, só as telas de entrada (para sair ou usar o link do e-mail).
const ROTAS_LIVRES = ['/login', '/recuperar-senha'];
export const rotaLiberadaNaTroca = (pathname = '') => (
  pathname === ROTA_TROCA_SENHA
  || ROTAS_LIVRES.includes(pathname)
  || pathname.startsWith('/redefinir-senha/')
);

export const ehRespostaDeTrocaObrigatoria = (error) => (
  error?.response?.status === 403 && error?.response?.data?.codigo === CODIGO_TROCA_SENHA
);
